export const invoiceDataGridColumns = [
  { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // 🛠️ Add this line
  { key: 'id', label: 'Id', sortable: true, sticky: false },
  { key: 'invoiceDate', label: 'Invoice Date', sortable: true },
  { key: 'importDate', label: 'Import Date', sortable: true },
  { key: 'role', label: 'Type', sortable: true, sticky: false },
  { key: 'invoiceId', label: 'Invoice Id', sortable: true, sticky: false },
  { key: 'profileName', label: 'Name', sortable: true, sticky: false },
  { key: 'amount', label: 'Amount', sortable: true },
  { key: 'importStatus', label: 'Import Status', sortable: true },
  { key: 'mutationType', label: 'Invoice Type', sortable: true, sticky: false },
  { key: 'taskId', label: 'TaskId', sortable: true, sticky: false },
  { key: 'profileId', label: 'Profile Id', sortable: true, sticky: false },
  { key: 'amountAdminFee', label: 'Admin Fee', sortable: true },
  { key: 'amountDownpayment', label: 'Downpayment', sortable: true },
  { key: 'amountVat', label: 'VAT Amount', sortable: true },
  { key: 'creationDate', label: 'Creation Date', sortable: true },
  { key: 'eolContactId', label: 'Eol Contact Id', sortable: true },
  { key: 'eolInvoiceNumber', label: 'Eol Invoice Number', sortable: true },
  { key: 'journal', label: 'Journal', sortable: true, sticky: false },
  { key: 'importCounter', label: 'Import Counter', sortable: true },
  { key: 'actions', label: 'Actions', sortable: false, sticky: false },
];
